// import { useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import store from './store/store'

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000,
})

axiosInstance.interceptors.request.use((axiosConfig) => {
  const accessToken = store.getState().user?.access_token
  if (accessToken) {
    axiosConfig.headers.Authorization = `Bearer ${accessToken}`
  }

  return axiosConfig
})

axiosInstance.interceptors.response.use(
  response => response,
  (error) => {
    if (error.response && (typeof error.response.data.errors === 'string' || error.response.data.errors instanceof String)) {
      error.response.data.errors = { general: [error.response.data.errors] }
    } else if (!error.response || error.response.status === 500) {
      error.response = {
        data: {
          errors: { general: ['Something went wrong, please try again'] },
        },
      }
    } else if (error.response.status === 503) {
      const message = error.response.data?.message || 'This feature is currently unavailable.'
      error.response.data = {
        errors: { general: [message] },
      }
    }

    if (error.response && error.response.status === 401) {
      window.location = '/log-in' // TODO: Find better solution
      // navigate('/log-in')
    }

    return Promise.reject(error)
  }
)

export default axiosInstance
